export const ATLANTA_MARKET_ID = `c4fe746b-2239-4cee-b8a4-270e7a079518`;

export const PAGES = {
  SIGN_UP: 'getstarted',
  HOME: 'home',
  CONTACT: 'contact',
  SERVICES: 'services',
  PAYMENT: 'payment',
  CART: 'cart/:subscriptionId',
  CART_NOT_FOUND: 'cart-not-found',
  OUT_OF_AREA: 'out-of-area',
  ADDRESS_HAS_PLAN: 'address-has-plan',
  SQUARE_FOOT: 'square-foot',
  REVIEW: 'review',
  HOUSE_SIZE: 'house-size',
  REFERRAL_CODE: '/r/:referralCode',
  CAMPAIGN_CODE: '/c/:campaignCode',
  PLAN_EXISTS: 'plan-exists',
  SUCCESS: 'success',
  MEET_PARAMETERIZED: '/meet/:meetCode',
  MEET_DEFAULT: '/meet',
  MEET_CUSTOMER_DETAILS: '/customer',
  SCHEDULE: '/schedule',
  SCHEDULED: '/meeting-scheduled',
};
export const CUSTOMER_ACTIONS = {
  SET_TSHIRT_SIZE: 'SET_TSHIRT_SIZE',
  HOME: 'home',
  SERVICES: 'services',
  PAYMENT: 'payment',
  OUT_OF_AREA: 'out-of-area',
  ADDRESS_HAS_PLAN: 'address-has-plan',
  SQUARE_FOOT: 'square-foot',
  REVIEW: 'review',
  HOUSE_SIZE: 'house-size',
  HELP: 'help',
  COMPLETE: 'complete',
  CONTACT: 'contact',
  LOCAL_SESSION_KEY: 'digscustomer',
  PLAN_EXISTS: 'plan-exists',
  UPDATE_SERVICES: 'update-services',
  MEET_CUSTOMER_DETAILS: 'meet-update-customer',
  CART: 'set-cart',
  LEADGEN: 'leadgen',
  SCHEDULE: 'schedule',
};
export const CUSTOMER_STATUS = {
  WAITLIST: 'waitlist',
};

export const CONFIGURATION = {
  SUPPORT_EMAIL: 'support@digs.company',
};

export const HOUSE_WASH_PRICE = 0.105; // 10 and half cents

export const PER_SERVICE = 'PER-SERVICE';
export const PER_MONTH = 'PER-MONTH';
export const CAMPAIGN_PRICING = {
  per_service: PER_SERVICE,
  v1: PER_SERVICE,
  per: PER_MONTH,
};
export const LATEST_CAMPAIGN = 'v1';

export const PER_MONTH_FAQ = [
  {
    question: 'What happens next?',
    answer:
      'After you sign up for your plan, your Digs team will reach out to you within 2 business days and begin to finalize your maintenance calendar. Your first service is usually scheduled within 30 days of activating your plan.',
  },
  {
    question: 'When will my services be scheduled?',
    answer:
      'After your services are added to the appropriate months on your maintenance calendar, your first service is usually scheduled within 30 days of activating your plan. The Digs scheduling team will be in touch with updates.',
  },
  {
    question: 'Will the prices change?',
    answer:
      'Prices provided during self-sign up are estimates based on the information that you provided. Most of the time, no changes are needed. If there are changes in the price of a service, that will be communicated with you for approval before the service is completed.',
  },
  {
    question: 'Can I make changes to my Digs Plan?',
    answer:
      'Yes! You can make changes to your Digs Plan. Just reach out to your Digs support team for help.',
  },
  {
    question: 'Can I cancel my Digs Plan?',
    answer:
      'We are committed to providing you with amazing service. However, we know that life sometimes takes unexpected turns. If you need to cancel, reach out to your Digs Support Team. Although we would hate to see you cancel, we will work with you to true-up your account based on the services completed in your plan for the year.',
  },
  {
    question: 'What kind of businesses perform the services?',
    answer:
      'Most of your services are performed by owner-operator, local, small businesses. We build relationships with these local businesses, who typically perform services for multiple Digs customers, representing a significant part of their customer base. This ensures you get the best response and maximum care.',
  },
  {
    question: 'Can I speak to someone first before signing up?',
    answer:
      'Absolutely! We’d love to talk to you. You can reach us by phone or text at 770-525-2215.',
  },
];

export const PER_SERVICE_FAQ = [
  {
    question: 'What happens next?',
    answer: `After you select the services that you are interested in, we'll schedule a short meeting to review your plan, services and pricing with you. Then we'll get started scheduling your first service!`,
  },
  {
    question: 'When will my card be charged?',
    answer: `The first charge on your card will take place at the completion of your first service. At that time, you will be charged your Digs Monthly Plan ($89) and the amount of the individual service that was completed. Your Digs Monthly Plan ($89) will be billed in recurring monthly payments from the date of the first service completed. All service payments are due and charged upon completion of the service.`,
  },
  {
    question: 'Will the prices change?',
    answer: `Prices provided during sign up are estimates based on the information that you provided and average costs. Most of the time, no changes are needed. If there are changes in the price of a service, that will be communicated with you for approval before the service is completed.`,
  },
  {
    question: 'Can I make changes to my Digs Plan?',
    answer: `Yes! You can make changes to your Digs Plan. Just reach out to your Digs support team for help.`,
  },
  {
    question: 'Can I cancel my Digs Plan?',
    answer: `We are committed to providing you with amazing service. However, we know that life sometimes takes unexpected turns. If you need to cancel, we understand. Just reach out to your Digs Support Team. Although we would hate to see you cancel, we will work with you to close out your account. There are no cancellation fees or penalties for canceling.`,
  },
  {
    question: 'What kind of businesses perform the services?',
    answer: `Most of your services are performed by owner-operator, local, small businesses. We build relationships with these local businesses, who typically perform services for multiple Digs customers, representing a significant part of their customer base. This ensures you get the best response and maximum care.`,
  },
  {
    question: 'When will my services be scheduled?',
    answer: `Your first service is usually scheduled within 30 days of activating your plan. All your services are added to the appropriate months on your maintenance calendar. Most appointments are scheduled by the beginning of each month. The Digs scheduling team will be in touch with updates as your services are scheduled.`,
  },
  {
    question: 'Can I speak to someone first before signing up?',
    answer: `Absolutely! We’d love to talk to you. You can reach us by phone or text at 770-525-2215.`,
  },
];

export const MEETING_SUCCESS_FAQ = [
  {
    question: 'What happens next?',
    answer: `During your meeting, your Digs team member will review your plan, services and pricing with you. Once your review is completed, your Digs plan will be activated.`,
  },
  {
    question: 'When will my card be charged?',
    answer: `The first charge on your card will take place at the completion of your first service. At that time, you will be charged your Digs Monthly Plan ($89) and the amount of the individual service that was completed. Your Digs Monthly Plan ($89) will be billed in recurring monthly payments from the date of the first service completed. All service payments are due and charged upon completion of the service.`,
  },
  {
    question: 'Will the prices change?',
    answer: `Prices provided during sign up are estimates based on the information that you provided and average costs. Most of the time, no changes are needed. If there are changes in the price of a service, that will be communicated with you for approval before the service is completed.`,
  },
  {
    question: 'Can I make changes to my Digs Plan?',
    answer: `Yes! You can make changes to your Digs Plan. Just reach out to your Digs support team for help.`,
  },
  {
    question: 'Can I cancel my Digs Plan?',
    answer: `We are committed to providing you with amazing service. However, we know that life sometimes takes unexpected turns. If you need to cancel, we understand. Just reach out to your Digs Support Team. Although we would hate to see you cancel, we will work with you to close out your account. There are no cancellation fees or penalties for canceling.`,
  },
  {
    question: 'What kind of businesses perform the services?',
    answer: `Most of your services are performed by owner-operator, local, small businesses. We build relationships with these local businesses, who typically perform services for multiple Digs customers, representing a significant part of their customer base. This ensures you get the best response and maximum care.`,
  },
  {
    question: 'When will my services be scheduled?',
    answer: `Your first service is usually scheduled within 30 days of activating your plan. All your services are added to the appropriate months on your maintenance calendar. Most appointments are scheduled by the beginning of each month. The Digs scheduling team will be in touch with updates as your services are scheduled.`,
  },
  {
    question: 'Can I speak to someone first before signing up?',
    answer: `Absolutely! We’d love to talk to you. You can reach us by phone or text at 770-525-2215.`,
  },
];
